import Card from "../UI/Card";
// @ts-expect-error pure js
import Photo from "../UI/Photo";
import Text from "../UI/Text";
import style from "./Property.module.css";
import type { Property } from "../../models/property";

interface PropertyDisplaySmallCardProps {
  property: Property;
  variant?: "row" | "stacked";
}

function PropertyDisplaySmallCard({
  property,
  variant = "row",
}: PropertyDisplaySmallCardProps) {
  const isStacked = variant === "stacked";

  const photo = property.main_photo_id ? (
    <Photo
      photoId={property.main_photo_id}
      type="property_photo"
      className={isStacked ? style.stackedImage : style.smallImage}
      alt="logement"
    />
  ) : (
    <img
      src={
        property.type === "commercial"
          ? "/default-photo-commercial.jpeg"
          : "/default-photo-appartement.jpeg"
      }
      alt="logement"
      className={isStacked ? style.stackedImage : style.smallImage}
    />
  );

  const address = `${property.rue}, ${property.complement_adresse || ""} ${
    property.cp
  } ${property.ville}`;

  if (isStacked) {
    return (
      <Card padding="xs" className={style.stackedCard} key={property.id}>
        {photo}
        <div className={style.stackedInfo}>
          <Text weight="bold">{property.nom}</Text>
          <Text variant="deci" color="muted">
            {address}
          </Text>
        </div>
      </Card>
    );
  }

  return (
    <Card
      className={"padding10 flex align-items-center marginB10"}
      key={property.id}
    >
      {photo}
      <div className={"marginL10"}>
        <Text weight="bold">{property.nom}</Text>
        <Text variant="deci" color="muted">
          {address}
        </Text>
      </div>
    </Card>
  );
}

export default PropertyDisplaySmallCard;
